import { useEffect } from 'react';

export type ContentProtectionOptions = {
  enabled?: boolean;
  watermark?: string;
  /** Flou quand l’onglet n’est pas visible (déterrent enregistrement) */
  blurOnHidden?: boolean;
};

function isEnabled(flag?: boolean): boolean {
  if (flag === false) return false;
  const env = import.meta.env.VITE_CONTENT_PROTECTION;
  if (env === 'false' || env === '0') return false;
  return import.meta.env.PROD || env === 'true' || env === '1';
}

export function useContentProtection(options: ContentProtectionOptions = {}) {
  const {
    enabled = true,
    watermark = 'L Benna Production',
    blurOnHidden = true,
  } = options;

  useEffect(() => {
    if (!isEnabled(enabled)) return;

    const block = (e: Event) => e.preventDefault();

    document.addEventListener('contextmenu', block);
    document.addEventListener('copy', block);
    document.addEventListener('cut', block);
    document.addEventListener('dragstart', block);

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'PrintScreen') {
        void navigator.clipboard?.writeText('').catch(() => undefined);
      }
    };
    document.addEventListener('keydown', onKeyDown);

    const onVisibility = () => {
      if (!blurOnHidden) return;
      document.documentElement.dataset.contentHidden = document.hidden
        ? 'true'
        : 'false';
    };
    document.addEventListener('visibilitychange', onVisibility);
    onVisibility();

    const onBeforePrint = () => {
      document.documentElement.dataset.printing = 'true';
    };
    const onAfterPrint = () => {
      delete document.documentElement.dataset.printing;
    };
    window.addEventListener('beforeprint', onBeforePrint);
    window.addEventListener('afterprint', onAfterPrint);

    document.documentElement.dataset.contentProtection = 'on';
    document.documentElement.dataset.watermark = watermark;

    return () => {
      document.removeEventListener('contextmenu', block);
      document.removeEventListener('copy', block);
      document.removeEventListener('cut', block);
      document.removeEventListener('dragstart', block);
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('beforeprint', onBeforePrint);
      window.removeEventListener('afterprint', onAfterPrint);
      delete document.documentElement.dataset.contentProtection;
      delete document.documentElement.dataset.contentHidden;
      delete document.documentElement.dataset.watermark;
      delete document.documentElement.dataset.printing;
    };
  }, [enabled, watermark, blurOnHidden]);
}
